import React from 'react';
import styled from 'styled-components';
import { typeface, get_color, respond } from '../../assets/styles';

const Title = styled.div`
    ${typeface('title4')} 
    display: flex;
    align-items: center;
    color: ${get_color('grey01')};
    height: 32px;
    margin-bottom: 16px;
    width: 316px;

    &:before {
        content: '';
        width: 4px;
        height: 32px;
        background-color: ${get_color('green02')};
        border-radius: 2px;
        margin-right: 12px;
    }
    ${respond(['m'], `
      ${typeface('title5')}
      &:before {
        margin-right: 8px;
      }
    `)}
    ${respond(['s'], `
      ${typeface('title7')}
      &:before {
        margin-right: 8px;
      }
    `)}
`

export interface PrimaryTitleProps {
  className?: string;
  style?: React.CSSProperties;
}

export const PrimaryTitle: React.FC<PrimaryTitleProps> = (props) => {
  const { className, style, children } = props;
  return (
    <Title role="heading" aria-level={2} className={className} style={style}>
      {children}
    </Title>
  );
};
